module.exports = __webpack_public_path__ + "direct-es2015.5170ea52c17d0408cfc5.worker.js"